import styled from "styled-components";
import blogBg from "../../../images/Blog/blog-bg.png";

const BlogBGStyles = {
    Container: styled.div`
        width: 100%;
        height: 140px;
        object-fit: cover;
        /* overflow: hidden; */
        background-image: url(${blogBg});
        background-position: 50% 50%;
        background-size: cover;
    `,
};

export default BlogBGStyles;
